import React, { useState } from 'react';

function About({ language = 'en' }) {
  const [showDetail, setShowDetail] = useState(false);

  if (showDetail) {
    return (
      <div id="about-detail-page" className="about-detail-page">
        <h2>
          {language === 'ar' ? 'من ' : 'ABOUT'}
          <span>{language === 'ar' ? 'نحن' : ' US'}</span>
        </h2>

        <div className="detail-content">
          <p>
            {language === 'ar' 
              ? 'تأسست الجبرية عام 1988، وبدأت رحلتها من خلال إدارة عمليات صناعية ومنشآت تصنيع كبيرة. ومنذ البدايات، ركزت المؤسسة على بناء معايير تشغيل قوية، وانضباط مالي، وشراكات طويلة الأمد'
              : 'Founded in 1988, Al-Jabriyah began its journey by managing multimillion-dollar industrial operations and manufacturing facilities. From the early years, the organization focused on building strong operational standards, financial discipline, and long-term partnerships.'
            }
          </p>
          <p>
            {language === 'ar' 
              ? 'ومع مرور الوقت، توسّعت الجبرية استراتيجيًا في مجالات الإنشاءات وتجارة الإلكترونيات ومشاريع التكييف، مما مكّنها من تقديم حلول متكاملة عبر عدة قطاعات، وعزّز مكانتها في السوق وقدرتها على خدمة القطاعين العام والخاص'
              : 'Over time, Al-Jabriyah strategically expanded into construction, electronics trading, and HVAC contracting, enabling the group to deliver integrated solutions across multiple sectors. This diversification strengthened its market position and enhanced its ability to serve both private and public sector clients.'
            }
          </p>
          <p>
            {language === 'ar' 
              ? 'وبخبرة تزيد عن 15 عامًا في إدارة الفعاليات والحلول التسويقية، قدّمت الجبرية حملات وطنية ومبادرات كبرى دعمت العلامات التجارية والمؤسسات والبرامج الحكومية في مختلف أنحاء المملكة'
              : 'With more than 15 years of experience in event management and marketing solutions, Al-Jabriyah has successfully delivered national campaigns and major public initiatives, supporting brands, institutions, and government programs across the Kingdom.'
            }
          </p>
          <p>
            {language === 'ar' 
              ? 'وفي عام 2025، أطلقت المجموعة كيانات متخصصة في تقنية المعلومات والاستشارات الإدارية، متوافقة مع مسار التحوّل ضمن رؤية المملكة 2030، وتركّز على الحلول الرقمية وتطوير المنظمات والخدمات الاستشارية الاستراتيجية التي تساعد العملاء على التعامل مع التغيير واغتنام الفرص الجديدة'
              : 'In 2025, the group launched specialized entities in information technology and management consulting, aligned with Saudi Arabia\'s Vision 2030 transformation. These entities focus on digital solutions, organizational development, and strategic advisory services that help clients navigate change and seize new opportunities.'
            }
          </p>
          <p>
            {language === 'ar' 
              ? 'اليوم، تواصل الجبرية ترسيخ إرثها القائم على الموثوقية والابتكار والشراكة، وتبقى ملتزمة بالمساهمة في التنمية المستدامة للمملكة، وتمكين الأعمال، ودعم النمو طويل الأمد في القطاعات الاقتصادية الرئيسية '
              : 'Today, Al-Jabriyah continues to build on its legacy of reliability, innovation, and partnership. The establishment remains committed to contributing to the Kingdom\'s sustainable development, empowering businesses, and enabling long-term growth across key economic sectors.'
            }
          </p>
        </div>

        <div className="btn-container">
          <button className="back-btn" onClick={() => setShowDetail(false)}>
            {language === 'ar' ? 'الرجوع إلى قسم من نحن' : 'BACK TO ABOUT'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <section className="about" id="about">
      <div className="bg-shape-1"></div>
      <div className="bg-shape-2"></div>

      <h2 className="about-title">
        {language === 'ar' ? 'من ' : 'ABOUT'}
        <span>{language === 'ar' ? 'نحن' : ' US'}</span>
      </h2>

      <div className="about-inner">
        <div className="about-left">
          <p>
            {language === 'ar' 
              ? 'تأسست الجبرية عام 1988، وبدأت أعمالها بنجاح في القطاع الصناعي من خلال إدارة منشآت تصنيع بملايين الريالات، ثم توسّعت استراتيجيًا إلى مجالات الإنشاءات وتجارة الإلكترونيات ومشاريع التكييف'
              : 'Established in 1988, Al-Jabriyah began with successful industrial sector operations, managing multimillion-dollar manufacturing facilities. The group strategically expanded into construction, electronics trading, and HVAC contracting.'
            }
          </p>
          <p>
            {language === 'ar' 
              ? 'وبخبرة تتجاوز 15 عامًا، دخلت الجبرية مجال إدارة الفعاليات والحلول التسويقية، ونفّذت حملات ناجحة على مستوى المملكة. وفي عام 2025، أطلقت كيانات مستقلة في تقنية المعلومات والاستشارات الإدارية بما ينسجم مع رؤية 2030'
              : 'With over 15 years of expertise, Al-Jabriyah entered event management and marketing solutions, delivering successful campaigns nationwide. In 2025, the establishment launched independent IT and management consulting entities aligned with Vision 2030.'
            }
          </p>
          <p>
            {language === 'ar' 
              ? 'استنادًا إلى إرثها ورؤيتها المستقبلية، تواصل الجبرية دفع عجلة نمو المنظمات والمساهمة في تطوير قطاع الأعمال بشكل مستدام في المملكة العربية السعودية'
              : 'Building on its legacy and forward-looking vision, Al-Jabriyah continues to drive organizational growth and contribute to Saudi Arabia\'s sustainable business development.'
            }
          </p>

          <button className="btn about-btn" onClick={() => setShowDetail(true)}>
            {language === 'ar' ? 'اقرأ المزيد' : 'READ MORE'}
          </button>
        </div>

        <div className="about-right"></div>
      </div>
    </section>
  );
}

export default About;